import CreateActComponent from "components/Project/Overview/Actas/createAct/CreateActComponent"
import React from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"

const newCreateAct = () => {
  return (
    <React.Fragment>
      <div className="page-content" style={{ overflow: "hidden" }}>
        <Helmet>
          <title>Planhopper | Actas</title>
        </Helmet>
        <Container fluid>
          <CreateActComponent />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default newCreateAct
